import { cn } from '@workspace/ui/lib/utils';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import {
  IconButton,
  type IconButtonProps,
} from '~/components/isolated/IconButton';

import type { ToolbarProps } from './interfaces';
import styles from './Toolbar.module.scss';

const Toolbar = ({
  className,
  mobileSort,
  mobileFilters,
  isLoading,
}: ToolbarProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={cn(styles.root, className)}>
        <Skeleton containerClassName={styles.searchBarSkeleton} />
        <Skeleton containerClassName={styles.btnSkeleton} circle />
        <Skeleton containerClassName={styles.btnSkeleton} circle />
      </div>
    );
  }

  const iconButtonCommonProps: Omit<IconButtonProps, 'icon' | 'onClick'> = {
    variant: company.match({
      mcosmetic: 'outline',
      default: 'default',
    }),
    size: 'L',
    className: company.match({
      mcosmetic: 'text-icon-primary!',
    }),
  };

  return (
    <div
      className={cn(
        styles.root,
        company.match({
          mcosmetic: 'mx-auto!',
        }),
        className,
      )}
    >
      <Link to="/search" className={styles.searchBar}>
        <Icon type="search-alt" size={16} />
        <span>{t('header:searchProducts')}</span>
      </Link>
      <IconButton
        {...iconButtonCommonProps}
        icon="sort-alt"
        onClick={mobileSort.open}
      />
      <IconButton
        {...iconButtonCommonProps}
        icon="filter-alt"
        onClick={mobileFilters.open}
      />
    </div>
  );
};

export default Toolbar;
